import { Component, OnInit } from '@angular/core';
import { Event, NavigationStart, Router, RouterEvent } from '@angular/router';
import { filter } from 'rxjs/operators';
import { LifecycleManager } from '../../../../../modules/src/lib/core/managers/lifecycle.manager';

@Component({
  selector: 'app-root',
  templateUrl: './root.component.html',
  styleUrls: ['./root.component.scss'],
  standalone: false,
})
export class RootComponent implements OnInit {

  constructor(private router: Router, private lifecycleManager: LifecycleManager) {
    router.events.pipe(filter(event => event instanceof NavigationStart))
      .subscribe((event: Event) => {

        // Hubspot code tracking to track every page visit of our customers.
        const _hsq = window['_hsq'] = window['_hsq'] || [];
        _hsq.push(['setPath', { path: (event as RouterEvent).url }]);
        _hsq.push(['trackPageView']);
      });
  }

  ngOnInit(): void {
    this.lifecycleManager.firstLoad();
  }
}
